import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { IAttribute, IModel, Metamodel } from 'shell-models-lib';
import { ArrayDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';

@Metamodel.model({
    name: 'dataflowexpressionarray'
})
export class DataFlowExpressionArray<T = DataFlowExpression> extends DataFlowExpression {
    public static readonly MODEL: IModel;
    public static readonly EXPRESSION: IAttribute;

    public expressions: T[] = [];
    protected _expectedReturnType = ArrayDataFlowType.TYPE;
    protected _cachedReturnType = new ArrayDataFlowType();

    public get(index: number) {
        return this.expressions[index];
    }

    public *[Symbol.iterator]() {
        for (const expression of this.expressions) {
            yield expression;
        }
    }

    public push(...expressions: T[]): number {
        return this.expressions.push(...expressions);
    }

    public splice(start: number, deleteCount: number, ...items: T[]): T[] {
        return this.expressions.splice(start, deleteCount, ...items);
    }
}
